export default __webpack_public_path__ + "static/media/dashboard.20c3c0c9.svg";